import tag from "../utilities/tag"
import uniqid from "uniqid";

export function createDropdownToggle(menuItem) {
  const toggleId = uniqid();
  const controls = menuItem.querySelector(".js-dropdown-menu");
  const dropdownToggle = tag("button", {
    class: "nav-dropdown-toggle js-dropdown-toggle",
    "aria-expanded": false,
    "aria-labelledby": `toggleLabel-${toggleId}`,
    "aria-controls": controls ? controls.id : null,
  });
  const toggleScreenreaderText = tag("span", {
    class: "sr-only",
    id: `toggleLabel-${toggleId}`,
  });
  const toggleIcon = tag("i", {
    class: "fal fa-angle-down",
  });

  dropdownToggle.appendChild(toggleIcon);
  toggleScreenreaderText.textContent = ctSrText.expandMenu;
  dropdownToggle.appendChild(toggleScreenreaderText);

  return dropdownToggle;
}
